// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c4fR7{padding:0 48px}.tbPHs{margin-top:32px}.Is7w6{min-width:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `c4fR7`,
	"ctaWrapper": `tbPHs`,
	"ctaButton": `Is7w6`
};
export default ___CSS_LOADER_EXPORT___;
